import axios, { resHandle } from "@/plugins/axios";

// enhancement 具体的接口定义以后再做
interface Hospital {
    hospital_id: string;
    医院名称: string;
    [propName: string]: any;
}

/**
 * @description 获取当前用户有权限可使用的分中心
 * @param vCom Vue组件
 * @param projectId 项目id
 */
const GetUserHospitals = (vCom: any, projectId: string, search?: string): Promise<any> => {
    return new Promise((resolve, reject) => {
        const params: any = {
            params: {
                project_id: projectId
            }
        };
        if (search) {
            params['params']['search'] = search;
        }
        axios.get("api/project/user/hospitals", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

export { GetUserHospitals, Hospital };


